import { FC } from 'react';
import { css } from '@emotion/react';
import { spacing, colors } from '../../../styles';

interface ParsedToolOutput {
  type?: string;
  status?: string;
  message?: string;
  [key: string]: any;
}

interface ToolRendererProps {
  toolName: string;
  output: ParsedToolOutput;
  isLoading?: boolean;
}

export const SentimentRenderer: FC<ToolRendererProps> = ({ output, isLoading }) => {
  if (isLoading) {
    return (
      <div
        css={css`
          font-size: 14px;
          color: ${colors.silver};
        `}
      >
        Analyzing sentiment...
      </div>
    );
  }

  const content = typeof output === 'string' ? output : output.content || '';
  if (content.includes('sentiment') || content.includes('bullish') || content.includes('bearish')) {
    return (
      <div
        css={css`
          font-size: 14px;
          color: ${colors.liquorice};
          line-height: 1.4;

          html[data-theme='dark'] & {
            color: ${colors.sugar};
          }
        `}
      >
        <div
          css={css`
            margin-bottom: ${spacing.centi};
          `}
        >
          Market sentiment analyzed
        </div>
        <div
          css={css`
            font-size: 12px;
            color: ${colors.silver};
          `}
        >
          {content.split('\n')[0].replace(/[#*]/g, '').trim()}
        </div>
      </div>
    );
  }

  return (
    <div
      css={css`
        font-size: 14px;
        color: ${colors.silver};
      `}
    >
      Sentiment analysis completed
    </div>
  );
};
